import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 导入vant-ui组件
import '@/utils/vant-ui'

// 重置默认样式
import '@/styles/common.less'

// 引入 Vant 样式（确保 Icon 样式生效）
import 'vant/lib/index.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')